import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { VENDOR_CHANGE_PASSWORD, VENDOR_CHANGE_PASSWORD_SUCCESS, VENDOR_CHANGE_PASSWORD_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* changeVendorPassword({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/vendors/change-password`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: VENDOR_CHANGE_PASSWORD_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: VENDOR_CHANGE_PASSWORD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VENDOR_CHANGE_PASSWORD_ERROR, payload: error });
  }
}

export function* watchchangeVendorPassword() {
  yield takeEvery(VENDOR_CHANGE_PASSWORD, changeVendorPassword);
}

function* changeVendorPasswordSaga() {
  yield all([fork(watchchangeVendorPassword)]);
}

export default changeVendorPasswordSaga;
